import script from "./DatesElement.vue?vue&type=script&lang=js"
export * from "./DatesElement.vue?vue&type=script&lang=js"

import "./DatesElement.vue?vue&type=style&index=0&id=46ee81b6&lang=scss"

const __exports__ = script;

export default __exports__